import { Button } from "antd";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate } from "react-router";
import { DhamhaAungLanLogo } from "./icons";

export function NotFound() {

    const nav = useNavigate();

    return (
        <section
            className=" bg-primary-gradient animate-fade-in "
        >
            <div
                className="flex items-center justify-center min-h-screen bg-black/30 p-4"
            >
                <article
                    className=" max-w-2xl w-full p-10  rounded flex flex-col gap-4 items-center justify-center text-white font-poppins "
                >
                    <DhamhaAungLanLogo
                        size={200}
                    />
                    <h2
                        className=" text-center text-5xl font-bold "
                    >
                        404!
                    </h2>
                    <p
                        className="text-2xl font-semibold"
                    >
                        Oops! Page not found.
                    </p>
                    <p>
                        The page you are looking for does not exist.
                    </p>


                    <Button
                        type="primary"
                        icon={<AiOutlineArrowLeft />}
                        size="large"
                        onClick={() => nav(-1)}
                    >
                        Back to Home
                    </Button>
                </article>
            </div>
        </section>
    )
}
